import { useEffect } from 'react';
import { fetchNotificationCount, isAuthenticated } from '../../utils/api';

export function useNotificationCount({ setNotificationCount, isInitializing, isShareView }) {
    useEffect(() => {
        if (isInitializing || isShareView || !isAuthenticated()) return;
        fetchNotificationCount()
            .then((res) => setNotificationCount(res?.data ?? 0))
            .catch(() => {});
    }, [isInitializing, isShareView, setNotificationCount]);
}
